import { EmtButton, EmtPaper } from 'emt-components-v2'
import { styled } from '@mui/material/styles'
import Menu from '@mui/material/Menu'

export const NewsCard: any = styled(EmtPaper)(() => ({
  position: 'relative',
  display: 'flex',
  minHeight: '104px',
  gap: '20px',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  padding: '12px 24px',
  '& .emt-icons': { fontSize: '24px' },
}))

export const HomeBottomCard: any = styled(EmtPaper)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '30px',
  height: 150,
  '& a': {
    textDecoration: 'none',
  },
  '& .emtPaper-home-card-innerContent': {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '10px',
  },
  '&.premium': {
    height: 'auto',
  },
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    '&.premium': {
      flexDirection: 'column',
      rowGap: '10px',
      background: 'transparent',
      padding: 0,
    },
  },
}))

export const NewsCardButton: any = styled(EmtButton)(() => ({
  borderWidth: '1px',
  '&:hover': {
    borderWidth: '1px',
  },
}))

export const ProfilMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    padding: '24px',
    borderRadius: '16px',
    zIndex: 120,
    '& ul': {
      background: 'white',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '20px',
      alignItems: 'start',
      '& span': {
        display: 'flex',
        flexDirection: 'initial',
      },
    },
  },
}))
